import update from 'immutability-helper'
import {
  CHANGE_EDITOR_STATUS, HIDE_FOOTER, SHOW_FOOTER,
  UPDATE_EDITOR_MODE,
  UPDATE_TOOLBAR_LEFT,
  UPDATE_MESSAGE, EDITOR_INITIALIZED, RED_TITLE_PLACEHOLDER
} from "../constants/ActionTypes"
import {EDITOR_MODE_RICH} from '../constants/EditorMode'
import { STATUS_EDITOR } from "../constants/EditorStatus"

const initialState = {
  toolbarLeft: 0,
  editorMode: EDITOR_MODE_RICH,
  editorStatus: STATUS_EDITOR,
  footerVisible: true,
  message: null,
  editorInitialized: false,
  redTitlePlaceholder: false,
};

export default (state = initialState, action) => {
  switch(action.type) {
    case UPDATE_EDITOR_MODE:
      return update(state, {
        editorMode: {
          $set: action.mode
        }
      });
    case CHANGE_EDITOR_STATUS:
      return update(state, {
        editorStatus: {
          $set: action.status
        }
      });
    case UPDATE_TOOLBAR_LEFT:
      return update(state, {
        toolbarLeft: {
          $set: action.left
        }
      });
    case SHOW_FOOTER:
      return update(state, {
        footerVisible: {
          $set: true
        }
      });
    case HIDE_FOOTER:
      return update(state, {
        footerVisible: {
          $set: false
        }
      });

    case UPDATE_MESSAGE:
      return update(state, {
        message: {
          $set: action.message
        }
      });

    case EDITOR_INITIALIZED:
      return update(state, {
        editorInitialized: {
          $set: true
        }
      });

    case RED_TITLE_PLACEHOLDER:
      return update(state, {
        redTitlePlaceholder: {
          $set: !!action.flag
        }
      });
  }
  return state
}
